<section class="text-align-center text-12 preview-banner-colour padding-5">
	<span *ngIf="pasPreview && !showAsOfDate" dcrHTMLKey="PAS_PREVIEW_BANNER_NO_DATE_TEXT">Note: You are viewing preview data</span>
	<span *ngIf="showAsOfDate" dcrHTMLKey="PAS_PREVIEW_BANNER_WITH_DATE_TEXT" [dcrSubstitutions]="{ $asOfDate$: asOfDate }"
		>Note: You are viewing preview data with data showing as of $asOfDate$
	</span>
</section>
